(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9934],{

/***/ 7645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 3644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(7294));
var _loadableContext = __webpack_require__(3644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7645)


/***/ }),

/***/ 8718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultRenderAnnounceSlideMessage = void 0;
const jsx_runtime_1 = __webpack_require__(5893);
const styles = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    padding: 0,
    margin: '-1px',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
};
const AnnounceSlide = ({ message, ariaLive = 'polite', }) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ "aria-live": ariaLive, "aria-atomic": "true", style: styles, tabIndex: -1 }, { children: message })));
const defaultRenderAnnounceSlideMessage = ({ currentSlide, count, }) => `Slide ${currentSlide + 1} of ${count}`;
exports.defaultRenderAnnounceSlideMessage = defaultRenderAnnounceSlideMessage;
exports["default"] = AnnounceSlide;
//# sourceMappingURL=announce-slide.js.map

/***/ }),

/***/ 3162:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Carousel = void 0;
const jsx_runtime_1 = __webpack_require__(5893);
const react_1 = __importStar(__webpack_require__(7294));
const slide_1 = __importDefault(__webpack_require__(802));
const announce_slide_1 = __importDefault(__webpack_require__(8718));
const slider_list_1 = __webpack_require__(1843);
const controls_1 = __importDefault(__webpack_require__(9267));
const default_carousel_props_1 = __importDefault(__webpack_require__(4834));
const utils_1 = __webpack_require__(1746);
const use_frame_height_1 = __webpack_require__(7825);
const default_controls_1 = __webpack_require__(2930);
const Carousel = (rawProps) => {
    /**
     * We need this cast because we want the component's properties to seem
     * optional to external users, but always-present for the internal
     * implementation.
     *
     * This cast is safe due to the `Carousel.defaultProps = defaultProps;`
     * statement below. That guarantees all the properties are present, since
     * `defaultProps` has type `InternalCarouselProps`.
     */
    const props = rawProps;
    const { adaptiveHeight, adaptiveHeightAnimation, afterSlide, animation, autoplay, autoplayInterval, autoplayReverse, beforeSlide, cellAlign, cellSpacing, children, className, disableAnimation, dragging: desktopDraggingEnabled, dragThreshold: propsDragThreshold, enableKeyboardControls, frameAriaLabel, innerRef, keyCodeConfig, onDrag, onDragEnd, onDragStart, onUserNavigation, pauseOnHover, renderAnnounceSlideMessage, scrollMode, slideIndex, slidesToScroll: propsSlidesToScroll, slidesToShow, speed, style, swiping: mobileDraggingEnabled, wrapAround, zoomScale, } = props;
    const filteredSlides = react_1.default.Children.toArray(children).filter(Boolean);
    const slideCount = filteredSlides.length;
    const slidesToScroll = animation === 'fade' ? slidesToShow : propsSlidesToScroll;
    const [currentSlide, setCurrentSlide] = (0, react_1.useState)(() => (0, utils_1.getDefaultSlideIndex)(slideIndex, slideCount, slidesToShow, slidesToScroll, cellAlign, autoplayReverse, scrollMode));
    const [pause, setPause] = (0, react_1.useState)(false);
    const [isDragging, setIsDragging] = (0, react_1.useState)(false);
    const [dragDistance, setDragDistance] = (0, react_1.useState)(0);
    const [animationDistance, setAnimationDistance] = (0, react_1.useState)(0);
    const prevXPosition = (0, react_1.useRef)(null);
    const preDragOffset = (0, react_1.useRef)(0);
    const sliderListRef = (0, react_1.useRef)(null);
    const defaultCarouselRef = (0, react_1.useRef)(null);
    const autoplayTimeout = (0, react_1.useRef)();
    const autoplayLastTriggeredRef = (0, react_1.useRef)(null);
    const isMounted = (0, react_1.useRef)(true);
    const setSliderListRef = (0, react_1.useCallback)((node) => {
        if (node) {
            // disable img draggable attribute by default, this will improve the dragging
            // applying the querySelectorAll on just the descendants of the sliderList prevents
            // impacting DOM elements outside our scope
            node
                .querySelectorAll('.slider-list img')
                .forEach((el) => el.setAttribute('draggable', 'false'));
        }
        sliderListRef.current = node;
    }, []);
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    const carouselRef = innerRef || defaultCarouselRef;
    const goToSlide = (0, react_1.useCallback)((targetSlideUnbounded) => {
        if (!sliderListRef.current || !carouselRef.current)
            return;
        const targetSlideBounded = (0, utils_1.getBoundedIndex)(targetSlideUnbounded, slideCount);
        const slideChanged = targetSlideUnbounded !== currentSlide;
        slideChanged && beforeSlide(currentSlide, targetSlideBounded);
        // Calculate the distance the slide transition animation needs to cover.
        const currentOffset = sliderListRef.current.getBoundingClientRect().left -
            carouselRef.current.getBoundingClientRect().left;
        const sliderWidth = sliderListRef.current.offsetWidth;
        let targetOffset = ((0, slider_list_1.getPercentOffsetForSlide)(targetSlideBounded, slideCount, slidesToShow, cellAlign, wrapAround) /
            100) *
            sliderWidth;
        if (wrapAround) {
            // We have to do a bit of a recovery effort to figure out the closest
            // offset based on the direction we're going in the slides. The reason
            // it's complicated is because, when wrapped, both the current offset
            // and the calculated target offset are based on bounded slide indices -
            // that is, when wrapping, we often skip back to the first or last slide
            // seamlessly to make the carousel appear to infinitely repeat
            // The DOM width of `slideCount` slides
            const slideSetWidth = sliderWidth / 3;
            if (targetSlideUnbounded < 0) {
                targetOffset += slideSetWidth;
            }
            if (targetSlideUnbounded >= slideCount) {
                targetOffset -= slideSetWidth;
            }
        }
        setAnimationDistance(targetOffset - currentOffset);
        if (slideChanged) {
            setCurrentSlide(targetSlideBounded);
            // if animation is disabled decrease the speed to 40
            const msToEndOfAnimation = !disableAnimation ? speed || 500 : 40;
            setTimeout(() => {
                if (!isMounted.current)
                    return;
                afterSlide(targetSlideBounded);
            }, msToEndOfAnimation);
        }
    }, [
        afterSlide,
        beforeSlide,
        carouselRef,
        cellAlign,
        currentSlide,
        disableAnimation,
        speed,
        slideCount,
        slidesToShow,
        wrapAround,
    ]);
    const nextSlide = (0, react_1.useCallback)(() => {
        const nextSlideIndex = (0, utils_1.getNextMoveIndex)(scrollMode, wrapAround, currentSlide, slideCount, slidesToScroll, slidesToShow, cellAlign);
        if (currentSlide !== nextSlideIndex) {
            goToSlide(nextSlideIndex);
        }
    }, [
        cellAlign,
        currentSlide,
        goToSlide,
        slidesToScroll,
        scrollMode,
        slideCount,
        slidesToShow,
        wrapAround,
    ]);
    const prevSlide = (0, react_1.useCallback)(() => {
        const prevSlideIndex = (0, utils_1.getPrevMoveIndex)(scrollMode, wrapAround, currentSlide, slidesToScroll, slidesToShow, cellAlign);
        if (currentSlide !== prevSlideIndex) {
            goToSlide(prevSlideIndex);
        }
    }, [
        cellAlign,
        currentSlide,
        goToSlide,
        slidesToScroll,
        scrollMode,
        slidesToShow,
        wrapAround,
    ]);
    // When user changed the slideIndex property from outside.
    const prevMovedToSlideIndex = (0, react_1.useRef)(slideIndex);
    (0, react_1.useEffect)(() => {
        if (slideIndex !== undefined &&
            slideIndex !== prevMovedToSlideIndex.current &&
            !autoplayReverse) {
            goToSlide(slideIndex);
            prevMovedToSlideIndex.current = slideIndex;
        }
    }, [slideIndex, autoplayReverse, goToSlide]);
    (0, react_1.useEffect)(() => {
        let pauseStarted = null;
        // Keep track of when autoplay was paused so we can resume it with the same
        // remaining time to the next slide transition
        if (pause) {
            pauseStarted = Date.now();
        }
        return () => {
            if (pauseStarted !== null && autoplayLastTriggeredRef.current !== null) {
                autoplayLastTriggeredRef.current += Date.now() - pauseStarted;
            }
        };
    }, [pause]);
    (0, react_1.useEffect)(() => {
        if (autoplay && !pause) {
            // Adjust the timeout duration to account for changes that triggered the
            // re-creation of this timeout, such as the currentSlide being changed
            // periodically to make wrapAround loop forever
            const adjustedTimeoutMs = autoplayLastTriggeredRef.current !== null
                ? autoplayInterval - (Date.now() - autoplayLastTriggeredRef.current)
                : autoplayInterval;
            autoplayTimeout.current = setTimeout(() => {
                autoplayLastTriggeredRef.current = Date.now();
                if (autoplayReverse) {
                    prevSlide();
                }
                else {
                    nextSlide();
                }
            }, adjustedTimeoutMs);
        }
        // Clear the timeout if user hover on carousel
        if (autoplay && pause) {
            clearTimeout(autoplayTimeout.current);
        }
        return () => {
            clearTimeout(autoplayTimeout.current);
        };
    }, [
        pause,
        autoplay,
        autoplayInterval,
        autoplayReverse,
        prevSlide,
        nextSlide,
    ]);
    const onKeyDown = (event) => {
        let keyCommand = null;
        Object.keys(keyCodeConfig).forEach((command) => {
            var _a;
            if ((_a = keyCodeConfig[command]) === null || _a === void 0 ? void 0 : _a.includes(event.keyCode)) {
                keyCommand = command;
            }
        });
        if (keyCommand === null)
            return;
        // At this point we know some action is going to be triggered, so we
        // preventDefault to avoid the browser interpreting the key event and
        // stopPropagation to avoid any higher-up handlers from interpreting it.
        event.preventDefault();
        event.stopPropagation();
        switch (keyCommand) {
            case 'nextSlide':
                onUserNavigation(event);
                nextSlide();
                break;
            case 'previousSlide':
                onUserNavigation(event);
                prevSlide();
                break;
            case 'firstSlide':
            case 'lastSlide': {
                onUserNavigation(event);
                const dotIndices = (0, default_controls_1.getDotIndexes)(slideCount, slidesToScroll, scrollMode, slidesToShow, wrapAround, cellAlign);
                if (keyCommand === 'firstSlide') {
                    goToSlide(dotIndices[0]);
                }
                else {
                    goToSlide(dotIndices[dotIndices.length - 1]);
                }
                break;
            }
            case 'pause':
                setPause((p) => !p);
                break;
        }
    };
    const dragPositions = (0, react_1.useRef)([]);
    const handleDragEnd = (e) => {
        if (!isDragging || !carouselRef.current)
            return;
        setIsDragging(false);
        // Inertia calculation is used to allow quick flicks to scroll the carousel
        // where they might not based on the start and end points of the gesture
        // alone. In certain conditions, the inertia may also scroll the carousel
        // several times.
        let distanceFromInertia = 0;
        if (dragPositions.current.length > 1) {
            const startMove = dragPositions.current[0];
            const endMove = dragPositions.current[dragPositions.current.length - 1];
            const timeOffset = endMove.time - startMove.time;
            const goodInertiaFeelConstant = 9;
            const goodFrictionFeelConstant = 0.92;
            const initialVelocity = goodInertiaFeelConstant *
                Math.abs((endMove.pos - startMove.pos) / timeOffset);
            let velocity = initialVelocity;
            while (Math.abs(velocity) > 1) {
                distanceFromInertia += velocity;
                velocity *= goodFrictionFeelConstant;
            }
        }
        dragPositions.current = [];
        const adjustedDragDistance = Math.abs(dragDistance) + Math.abs(distanceFromInertia);
        onDragEnd(e);
        prevXPosition.current = null;
        setDragDistance(0);
        const oneScrollWidth = carouselRef.current.offsetWidth *
            Math.min(1, slidesToScroll / slidesToShow);
        const dragThreshold = oneScrollWidth * propsDragThreshold;
        if (adjustedDragDistance < dragThreshold) {
            goToSlide(currentSlide);
            return;
        }
        // If skipping over multiple slides at a time is still roughly trackable by
        // your eyes, we allow for skipping multiple slides with a single gesture.
        // This formula is just based off an observation that it is confusing to
        // skip from slides 1 to 3 when only one slide is shown at a time, but
        // skipping from 1 to 4 or so with two slides shown at a time is pulled-back
        // enough that you can still roughly keep track of your place in the
        // carousel.
        const canMaintainVisualContinuity = slidesToShow >= 2 * slidesToScroll;
        const timesToMove = canMaintainVisualContinuity
            ? 1 + Math.floor((adjustedDragDistance - dragThreshold) / oneScrollWidth)
            : 1;
        let nextSlideIndex = currentSlide;
        for (let index = 0; index < timesToMove; index += 1) {
            if (dragDistance > 0) {
                nextSlideIndex = (0, utils_1.getNextMoveIndex)(scrollMode, wrapAround, nextSlideIndex, slideCount, slidesToScroll, slidesToShow, cellAlign);
            }
            else {
                nextSlideIndex = (0, utils_1.getPrevMoveIndex)(scrollMode, wrapAround, nextSlideIndex, slidesToScroll, slidesToShow, cellAlign);
            }
        }
        if (nextSlideIndex !== currentSlide) {
            onUserNavigation(e);
        }
        goToSlide(nextSlideIndex);
    };
    const onTouchStart = (0, react_1.useCallback)((e) => {
        if (!mobileDraggingEnabled ||
            !sliderListRef.current ||
            !carouselRef.current) {
            return;
        }
        setIsDragging(true);
        preDragOffset.current =
            sliderListRef.current.getBoundingClientRect().left -
                carouselRef.current.getBoundingClientRect().left;
        onDragStart(e);
    }, [carouselRef, onDragStart, mobileDraggingEnabled]);
    const handlePointerMove = (0, react_1.useCallback)((xPosition) => {
        if (!isDragging)
            return;
        const isFirstMove = prevXPosition.current === null;
        const delta = prevXPosition.current !== null ? xPosition - prevXPosition.current : 0;
        const nextDragDistance = dragDistance + delta;
        const now = Date.now();
        // Maintain a buffer of drag positions from the last 100ms
        while (dragPositions.current.length > 0) {
            if (now - dragPositions.current[0].time <= 100) {
                break;
            }
            dragPositions.current.shift();
        }
        dragPositions.current.push({ pos: nextDragDistance, time: now });
        if (!isFirstMove) {
            // nextDragDistance will always be `0` on the first move event, so we
            // skip it because the value is already set to 0 at this point
            setDragDistance(nextDragDistance);
        }
        prevXPosition.current = xPosition;
    }, [isDragging, dragDistance]);
    const onTouchMove = (0, react_1.useCallback)((e) => {
        if (!isDragging || !carouselRef.current)
            return;
        onDragStart(e);
        const moveValue = carouselRef.current.offsetWidth - e.touches[0].pageX;
        handlePointerMove(moveValue);
    }, [isDragging, carouselRef, handlePointerMove, onDragStart]);
    const onMouseDown = (0, react_1.useCallback)((e) => {
        if (!desktopDraggingEnabled ||
            !sliderListRef.current ||
            !carouselRef.current)
            return;
        setIsDragging(true);
        preDragOffset.current =
            sliderListRef.current.getBoundingClientRect().left -
                carouselRef.current.getBoundingClientRect().left;
        onDragStart(e);
    }, [carouselRef, desktopDraggingEnabled, onDragStart]);
    const onMouseMove = (0, react_1.useCallback)((e) => {
        if (!isDragging || !carouselRef.current)
            return;
        onDrag(e);
        const offsetX = e.clientX - carouselRef.current.getBoundingClientRect().left;
        const moveValue = carouselRef.current.offsetWidth - offsetX;
        handlePointerMove(moveValue);
    }, [carouselRef, isDragging, handlePointerMove, onDrag]);
    const onMouseUp = (e) => {
        e.preventDefault();
        handleDragEnd(e);
    };
    const onMouseEnter = (0, react_1.useCallback)(() => {
        if (pauseOnHover) {
            setPause(true);
        }
    }, [pauseOnHover]);
    const onMouseLeave = (0, react_1.useCallback)(() => {
        if (pauseOnHover) {
            setPause(false);
        }
    }, [pauseOnHover]);
    const { frameHeight, handleVisibleSlideHeightChange, initializedAdaptiveHeight, } = (0, use_frame_height_1.useFrameHeight)(adaptiveHeight, slidesToShow, slideCount);
    const renderSlides = (typeOfSlide) => {
        const slides = filteredSlides.map((child, index) => {
            return ((0, jsx_runtime_1.jsx)(slide_1.default, Object.assign({ count: slideCount, currentSlide: currentSlide, index: index, isCurrentSlide: currentSlide === index, typeOfSlide: typeOfSlide, wrapAround: wrapAround, cellSpacing: cellSpacing, animation: animation, slidesToShow: slidesToShow, speed: speed, zoomScale: zoomScale, cellAlign: cellAlign, onVisibleSlideHeightChange: handleVisibleSlideHeightChange, adaptiveHeight: adaptiveHeight, initializedAdaptiveHeight: initializedAdaptiveHeight }, { children: child }), `${typeOfSlide}-${index}`));
        });
        return slides;
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'slider-container', style: {
            position: 'relative',
        }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: [(0, jsx_runtime_1.jsx)(announce_slide_1.default, { ariaLive: autoplay && !pause ? 'off' : 'polite', message: renderAnnounceSlideMessage({
                    currentSlide,
                    count: slideCount,
                }) }), (0, controls_1.default)(props, slideCount, currentSlide, goToSlide, nextSlide, prevSlide, slidesToScroll), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: ['slider-frame', className || ''].join(' ').trim(), style: Object.assign({ overflow: 'hidden', width: '100%', position: 'relative', outline: 'none', height: frameHeight, transition: adaptiveHeightAnimation
                        ? 'height 300ms ease-in-out'
                        : undefined, willChange: 'height', userSelect: 'none' }, style), "aria-label": frameAriaLabel, role: "region", tabIndex: enableKeyboardControls ? 0 : -1, onKeyDown: enableKeyboardControls ? onKeyDown : undefined, ref: carouselRef, onMouseUp: onMouseUp, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseLeave: onMouseUp, onTouchStart: onTouchStart, onTouchEnd: handleDragEnd, onTouchMove: onTouchMove }, { children: (0, jsx_runtime_1.jsxs)(slider_list_1.SliderList, Object.assign({ animationDistance: animationDistance, cellAlign: cellAlign, currentSlide: currentSlide, disableEdgeSwiping: props.disableEdgeSwiping, draggedOffset: preDragOffset.current - dragDistance, disableAnimation: disableAnimation, easing: props.easing, edgeEasing: props.edgeEasing, isDragging: isDragging, ref: setSliderListRef, scrollMode: scrollMode, animation: animation, slideCount: slideCount, slidesToScroll: slidesToScroll, slidesToShow: slidesToShow, speed: speed, wrapAround: wrapAround }, { children: [wrapAround ? renderSlides('prev-cloned') : null, renderSlides(), wrapAround ? renderSlides('next-cloned') : null] })) }))] })));
};
exports.Carousel = Carousel;
exports.Carousel.defaultProps = default_carousel_props_1.default;
exports["default"] = exports.Carousel;
//# sourceMappingURL=carousel.js.map

/***/ }),

/***/ 9519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getControlContainerStyles = void 0;
const types_1 = __webpack_require__(6428);
const commonStyles = {
    position: 'absolute',
    display: 'flex',
    zIndex: 1,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
};
/**
 * Gets flexbox alignment and justify-content styles for a given position.
 */
const getControlContainerFlexStyles = (pos) => {
    let alignItems;
    switch (pos) {
        case types_1.Positions.TopLeft:
        case types_1.Positions.TopCenter:
        case types_1.Positions.TopRight:
            alignItems = 'flex-start';
            break;
        case types_1.Positions.CenterLeft:
        case types_1.Positions.CenterCenter:
        case types_1.Positions.CenterRight:
            alignItems = 'center';
            break;
        case types_1.Positions.BottomLeft:
        case types_1.Positions.BottomCenter:
        case types_1.Positions.BottomRight:
            alignItems = 'flex-end';
            break;
    }
    let justifyContent;
    switch (pos) {
        case types_1.Positions.TopLeft:
        case types_1.Positions.CenterLeft:
        case types_1.Positions.BottomLeft:
            justifyContent = 'flex-start';
            break;
        case types_1.Positions.TopCenter:
        case types_1.Positions.CenterCenter:
        case types_1.Positions.BottomCenter:
            justifyContent = 'center';
            break;
        case types_1.Positions.TopRight:
        case types_1.Positions.CenterRight:
        case types_1.Positions.BottomRight:
            justifyContent = 'flex-end';
            break;
    }
    return { alignItems, justifyContent };
};
/**
 * Gets the styles for a back/forward control container to align the control
 * properly within the parent.
 */
const getControlContainerStyles = (pos) => {
    return Object.assign(Object.assign({}, getControlContainerFlexStyles(pos)), commonStyles);
};
exports.getControlContainerStyles = getControlContainerStyles;
//# sourceMappingURL=control-styles.js.map

/***/ }),

/***/ 9267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(5893);
const react_1 = __webpack_require__(7294);
const control_styles_1 = __webpack_require__(9519);
const default_controls_1 = __webpack_require__(2930);
const types_1 = __webpack_require__(6428);
const controlsMap = [
    { funcName: 'renderTopLeftControls', key: types_1.Positions.TopLeft },
    { funcName: 'renderTopCenterControls', key: types_1.Positions.TopCenter },
    { funcName: 'renderTopRightControls', key: types_1.Positions.TopRight },
    { funcName: 'renderCenterLeftControls', key: types_1.Positions.CenterLeft },
    { funcName: 'renderCenterCenterControls', key: types_1.Positions.CenterCenter },
    { funcName: 'renderCenterRightControls', key: types_1.Positions.CenterRight },
    { funcName: 'renderBottomLeftControls', key: types_1.Positions.BottomLeft },
    { funcName: 'renderBottomCenterControls', key: types_1.Positions.BottomCenter },
    { funcName: 'renderBottomRightControls', key: types_1.Positions.BottomRight },
];
const renderControls = (props, slideCount, currentSlide, goToSlide, nextSlide, prevSlide, slidesToScroll) => {
    if (props.withoutControls) {
        return null;
    }
    const disableCheckProps = Object.assign(Object.assign({}, props), { currentSlide,
        slideCount });
    const nextDisabled = (0, default_controls_1.nextButtonDisabled)(disableCheckProps);
    const previousDisabled = (0, default_controls_1.prevButtonDisabled)(disableCheckProps);
    const pagingDotsIndices = (0, default_controls_1.getDotIndexes)(slideCount, slidesToScroll, props.scrollMode, props.slidesToShow, props.wrapAround, props.cellAlign);
    return controlsMap.map((control) => {
        var _a;
        if (!props[control.funcName] ||
            typeof props[control.funcName] !== 'function') {
            return (0, jsx_runtime_1.jsx)(react_1.Fragment, {}, control.funcName);
        }
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: Object.assign(Object.assign({}, (0, control_styles_1.getControlContainerStyles)(control.key)), { pointerEvents: 'none' }) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: [
                    `slider-control-${control.key.toLowerCase()}`,
                    props.defaultControlsConfig.containerClassName || '',
                ]
                    .join(' ')
                    .trim(), 
                // The container has `pointerEvents: 'none'` so we need to override
                // that to make sure the controls are clickable.
                style: { pointerEvents: 'auto' } }, { children: (_a = props[control.funcName]) === null || _a === void 0 ? void 0 : _a.call(props, {
                    cellAlign: props.cellAlign,
                    cellSpacing: props.cellSpacing,
                    currentSlide,
                    defaultControlsConfig: props.defaultControlsConfig || {},
                    pagingDotsIndices,
                    goToSlide,
                    nextDisabled,
                    nextSlide,
                    onUserNavigation: props.onUserNavigation,
                    previousDisabled,
                    previousSlide: prevSlide,
                    scrollMode: props.scrollMode,
                    slideCount,
                    slidesToScroll,
                    slidesToShow: props.slidesToShow || 1,
                    vertical: props.vertical,
                    wrapAround: props.wrapAround,
                }) })) }), control.funcName));
    });
};
exports["default"] = renderControls;
//# sourceMappingURL=controls.js.map

/***/ }),

/***/ 4834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(5893);
const types_1 = __webpack_require__(6428);
const default_controls_1 = __webpack_require__(2930);
const announce_slide_1 = __webpack_require__(8718);
const easeOut = (t) => Math.pow((t - 1), 3) + 1;
const defaultProps = {
    adaptiveHeight: false,
    adaptiveHeightAnimation: true,
    afterSlide: () => {
        // do nothing
    },
    autoplay: false,
    autoplayInterval: 3000,
    autoplayReverse: false,
    beforeSlide: () => {
        // do nothing
    },
    cellAlign: 'left',
    cellSpacing: 0,
    defaultControlsConfig: {},
    disableAnimation: false,
    disableEdgeSwiping: false,
    dragging: true,
    dragThreshold: 0.5,
    easing: easeOut,
    edgeEasing: easeOut,
    enableKeyboardControls: false,
    frameAriaLabel: 'carousel-slider',
    keyCodeConfig: {
        nextSlide: [39, 68, 38, 87],
        previousSlide: [37, 65, 40, 83],
        firstSlide: [81],
        lastSlide: [69],
        pause: [32],
    },
    onDragStart: () => {
        // do nothing
    },
    onDrag: () => {
        // do nothing
    },
    onDragEnd: () => {
        // do nothing
    },
    onUserNavigation: () => {
        // do nothing
    },
    pauseOnHover: true,
    renderAnnounceSlideMessage: announce_slide_1.defaultRenderAnnounceSlideMessage,
    renderBottomCenterControls: (props) => ((0, jsx_runtime_1.jsx)(default_controls_1.PagingDots, Object.assign({}, props))),
    renderCenterLeftControls: (props) => ((0, jsx_runtime_1.jsx)(default_controls_1.PreviousButton, Object.assign({}, props))),
    renderCenterRightControls: (props) => (0, jsx_runtime_1.jsx)(default_controls_1.NextButton, Object.assign({}, props)),
    scrollMode: types_1.ScrollMode.page,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    style: {},
    swiping: true,
    vertical: false,
    withoutControls: false,
    wrapAround: false,
    children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
};
exports["default"] = defaultProps;
//# sourceMappingURL=default-carousel-props.js.map

/***/ }),

/***/ 2930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PagingDots = exports.getDotIndexes = exports.NextButton = exports.nextButtonDisabled = exports.PreviousButton = exports.prevButtonDisabled = void 0;
const jsx_runtime_1 = __webpack_require__(5893);
const react_1 = __webpack_require__(7294);
const types_1 = __webpack_require__(6428);
const utils_1 = __webpack_require__(1746);
const defaultButtonStyles = (disabled) => ({
    border: 0,
    background: 'rgba(0,0,0,0.4)',
    color: 'white',
    padding: 10,
    textTransform: 'uppercase',
    opacity: disabled ? 0.3 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer',
});
const prevButtonDisabled = ({ cellAlign, currentSlide, slidesToShow, wrapAround, }) => {
    // inifite carousel
    if (wrapAround) {
        return false;
    }
    // disable if displaying the leftmost slide
    if (currentSlide === 0) {
        return true;
    }
    // remainder scroll mode
    if (cellAlign === 'right' && currentSlide <= slidesToShow - 1) {
        return true;
    }
    return false;
};
exports.prevButtonDisabled = prevButtonDisabled;
const PreviousButton = ({ previousSlide, defaultControlsConfig: { prevButtonClassName, prevButtonStyle = {}, prevButtonText, prevButtonOnClick, }, onUserNavigation, previousDisabled: disabled, }) => {
    const handleClick = (event) => {
        prevButtonOnClick === null || prevButtonOnClick === void 0 ? void 0 : prevButtonOnClick(event);
        if (event.defaultPrevented)
            return;
        onUserNavigation(event);
        event.preventDefault();
        previousSlide();
    };
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: prevButtonClassName, style: Object.assign(Object.assign({}, defaultButtonStyles(disabled)), prevButtonStyle), disabled: disabled, onClick: handleClick, "aria-label": "previous", type: "button" }, { children: prevButtonText || 'Prev' })));
};
exports.PreviousButton = PreviousButton;
const nextButtonDisabled = ({ cellAlign, currentSlide, slideCount, slidesToShow, wrapAround, }) => {
    // inifite carousel
    if (wrapAround) {
        return false;
    }
    // If we are at the last possible slide without wrap, disable
    if (currentSlide >= slideCount - 1) {
        return true;
    }
    // remainder scroll mode
    if (cellAlign === 'left' && currentSlide >= slideCount - slidesToShow) {
        return true;
    }
    return false;
};
exports.nextButtonDisabled = nextButtonDisabled;
const NextButton = ({ nextSlide, defaultControlsConfig: { nextButtonClassName, nextButtonStyle = {}, nextButtonText, nextButtonOnClick, }, nextDisabled: disabled, onUserNavigation, }) => {
    const handleClick = (event) => {
        nextButtonOnClick === null || nextButtonOnClick === void 0 ? void 0 : nextButtonOnClick(event);
        if (event.defaultPrevented)
            return;
        onUserNavigation(event);
        event.preventDefault();
        nextSlide();
    };
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: nextButtonClassName, style: Object.assign(Object.assign({}, defaultButtonStyles(disabled)), nextButtonStyle), disabled: disabled, onClick: handleClick, "aria-label": "next", type: "button" }, { children: nextButtonText || 'Next' })));
};
exports.NextButton = NextButton;
/**
 * Calculate the indices that each dot will jump to when clicked
 */
const getDotIndexes = (slideCount, slidesToScroll, scrollMode, slidesToShow, wrapAround, cellAlign) => {
    const dotIndexes = [];
    const scrollSlides = slidesToScroll <= 0 ? 1 : slidesToScroll;
    if (wrapAround) {
        for (let i = 0; i < slideCount; i += scrollSlides) {
            dotIndexes.push(i);
        }
        return dotIndexes;
    }
    if (cellAlign === 'center') {
        for (let i = 0; i < slideCount - 1; i += scrollSlides) {
            dotIndexes.push(i);
        }
        if (slideCount > 0) {
            dotIndexes.push(slideCount - 1);
        }
        return dotIndexes;
    }
    if (cellAlign === 'left') {
        if (slidesToShow >= slideCount) {
            return [0];
        }
        const lastPossibleIndexWithoutWhitespace = slideCount - slidesToShow;
        for (let i = 0; i < lastPossibleIndexWithoutWhitespace; i += scrollSlides) {
            dotIndexes.push(i);
        }
        if (scrollMode === types_1.ScrollMode.remainder) {
            dotIndexes.push(lastPossibleIndexWithoutWhitespace);
        }
        else {
            dotIndexes.push(dotIndexes[dotIndexes.length - 1] + scrollSlides);
        }
        return dotIndexes;
    }
    if (cellAlign === 'right') {
        if (slidesToShow >= slideCount) {
            return [slideCount - 1];
        }
        const firstPossibleIndexWithoutWhitespace = slidesToShow - 1;
        if (scrollMode === types_1.ScrollMode.remainder) {
            for (let i = firstPossibleIndexWithoutWhitespace; i < slideCount - 1; i += scrollSlides) {
                dotIndexes.push(i);
            }
            dotIndexes.push(slideCount - 1);
        }
        else {
            for (let i = slideCount - 1; i > firstPossibleIndexWithoutWhitespace; i -= scrollSlides) {
                dotIndexes.push(i);
            }
            dotIndexes.push(dotIndexes[dotIndexes.length - 1] - scrollSlides);
            dotIndexes.reverse();
        }
        return dotIndexes;
    }
    // We should never reach this, because the if statements above cover all
    // possible values of cellAlign
    return dotIndexes;
};
exports.getDotIndexes = getDotIndexes;
const PagingDots = ({ pagingDotsIndices, defaultControlsConfig: { pagingDotsContainerClassName, pagingDotsClassName, pagingDotsStyle = {}, pagingDotsOnClick, }, currentSlide, onUserNavigation, slideCount, goToSlide, }) => {
    const listStyles = {
        position: 'relative',
        top: -10,
        display: 'flex',
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    };
    const getButtonStyles = (0, react_1.useCallback)((active) => ({
        cursor: 'pointer',
        opacity: active ? 1 : 0.5,
        background: 'transparent',
        border: 'none',
        fill: 'black',
    }), []);
    const currentSlideBounded = (0, utils_1.getBoundedIndex)(currentSlide, slideCount);
    return ((0, jsx_runtime_1.jsx)("ul", Object.assign({ className: pagingDotsContainerClassName, style: listStyles }, { children: pagingDotsIndices.map((slideIndex, i) => {
            const isActive = currentSlideBounded === slideIndex ||
                // sets navigation dots active if the current slide falls in the current index range
                (currentSlideBounded < slideIndex &&
                    (i === 0 || currentSlideBounded > pagingDotsIndices[i - 1]));
            return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: isActive ? 'paging-item active' : 'paging-item' }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ className: pagingDotsClassName, type: "button", style: Object.assign(Object.assign({}, getButtonStyles(isActive)), pagingDotsStyle), onClick: (event) => {
                        pagingDotsOnClick === null || pagingDotsOnClick === void 0 ? void 0 : pagingDotsOnClick(event);
                        if (event.defaultPrevented)
                            return;
                        onUserNavigation(event);
                        goToSlide(slideIndex);
                    }, "aria-label": `slide ${slideIndex + 1} bullet`, "aria-selected": isActive }, { children: (0, jsx_runtime_1.jsx)("svg", Object.assign({ className: "paging-dot", width: "6", height: "6", "aria-hidden": "true", focusable: "false", viewBox: "0 0 6 6" }, { children: (0, jsx_runtime_1.jsx)("circle", { cx: "3", cy: "3", r: "3" }) })) })) }), slideIndex));
        }) })));
};
exports.PagingDots = PagingDots;
//# sourceMappingURL=default-controls.js.map

/***/ }),

/***/ 7825:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFrameHeight = void 0;
const react_1 = __webpack_require__(7294);
const use_state_with_ref_1 = __webpack_require__(1221);
/**
 * The frame height is normally, just `auto` (i.e., it expands to fit the
 * items), but in adaptiveHeight mode, it's the height of the tallest visible
 * item.
 *
 * In adaptiveHeight mode, we also switch between two states to ensure that
 * slides don't render with zero height when server-side-rendering:
 *
 * - When initializedAdaptiveHeight is false: the frame has height auto; visible
 *   slides have height auto; invisible slides have height 0
 * - The client sets initializedAdaptiveHeight to true once we've measured all
 *   the visible slides' heights
 * - When initializedAdaptiveHeight is true: the frame has height set to the
 *   tallest visible slide; all slides have height 100%
 */
const useFrameHeight = (adaptiveHeight, slidesToShow, slideCount) => {
    const [visibleHeights, setVisibleHeights, visibleHeightsRef] = (0, use_state_with_ref_1.useStateWithRef)([]);
    // Whether we've received heights of all initial visible heights
    const [initializedAdaptiveHeight, setInitializedAdaptiveHeight] = (0, react_1.useState)(false);
    const handleVisibleSlideHeightChange = (0, react_1.useCallback)((slideIndex, height) => {
        // Use the ref's value since it's always the latest value
        const latestVisibleHeights = visibleHeightsRef.current;
        let newVisibleHeights;
        if (height === null) {
            newVisibleHeights = latestVisibleHeights.filter((slideHeight) => slideHeight.slideIndex !== slideIndex);
        }
        else {
            newVisibleHeights = [...latestVisibleHeights, { slideIndex, height }];
        }
        setVisibleHeights(newVisibleHeights);
        if (newVisibleHeights.length >=
            Math.min(slideCount, Math.ceil(slidesToShow))) {
            setInitializedAdaptiveHeight(true);
        }
    }, [slideCount, setVisibleHeights, slidesToShow, visibleHeightsRef]);
    const frameHeight = (0, react_1.useMemo)(() => {
        if (adaptiveHeight) {
            // We want server-side-rendering to render the carousel with non-zero
            // height. to achieve this, we first set the height to `auto` until
            // we've received the heights of the visible slides. Then, we switch to
            // a mode where the frame controls the height.
            if (!initializedAdaptiveHeight) {
                return 'auto';
            }
            const maxHeight = Math.max(0, ...visibleHeights.map((height) => height.height));
            return `${maxHeight}px`;
        }
        else {
            return 'auto';
        }
    }, [adaptiveHeight, initializedAdaptiveHeight, visibleHeights]);
    return {
        handleVisibleSlideHeightChange,
        frameHeight,
        initializedAdaptiveHeight,
    };
};
exports.useFrameHeight = useFrameHeight;
//# sourceMappingURL=use-frame-height.js.map

/***/ }),

/***/ 1221:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStateWithRef = void 0;
const react_1 = __webpack_require__(7294);
/**
 * Like useState, but also returns a ref that's always instantly updated.
 *
 * This is useful in two cases:
 *
 * 1. You need to both force a re-render when a variable changes, and
 *    also avoid re-running side effects (for example, a network call), even
 *    before the state fully updates for the component.
 * 2. Multiple callbacks need to modify the same object or array before the
 *    state updates. For example, if one callback tries to append 4 to
 *    `[1, 2, 3]` and another tries to append 5, we may end up with only
 *    `[1, 2, 3, 5]` instead of `[1, 2, 3, 4, 5]`
 */
const useStateWithRef = (initialState) => {
    const [value, setValue] = (0, react_1.useState)(initialState);
    // Need to explicitly type this out, or the overloads can confuse the
    // compiler to think that this might be a React Component ref
    const valueRef = (0, react_1.useRef)(initialState);
    const setValueAndRef = (0, react_1.useCallback)((newValue) => {
        valueRef.current = newValue;
        setValue(newValue);
    }, []);
    return [value, setValueAndRef, valueRef];
};
exports.useStateWithRef = useStateWithRef;
//# sourceMappingURL=use-state-with-ref.js.map

/***/ }),

/***/ 3457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTween = void 0;
const react_1 = __webpack_require__(7294);
/**
 * Provides an interpolated value, beginning at 0 and ending at 1, based on a
 * provided duration and animation timing function.
 */
const useTween = (durationMs, easingFunction, 
// navigationNum is an combination of numbers that are stable when the
// animation should not be running or should continue running, but change when
// the animation should start running. In practice, this is a combination of
// the animation distance and slide index.
navigationNum, shouldInterrupt) => {
    const [normalizedTimeRaw, setNormalizedTime] = (0, react_1.useState)(1);
    const startTime = (0, react_1.useRef)(Date.now());
    const rAF = (0, react_1.useRef)();
    const isFirstRender = (0, react_1.useRef)(true);
    const lastNavigationNum = (0, react_1.useRef)(null);
    // Detect on the first render following navigation if the animation should
    // be running. If we wait for the useEffect, the first render will flash with
    // the slide in its destination position, before the animation triggers,
    // sending it back to the position of the first frame of the animation. This
    // approach is done in place of a useLayoutEffect, which has issues with SSR.
    const normalizedTime = lastNavigationNum.current === null ||
        lastNavigationNum.current === navigationNum ||
        shouldInterrupt
        ? normalizedTimeRaw
        : 0; // 0 here indicates the animation has begun
    (0, react_1.useEffect)(() => {
        lastNavigationNum.current = navigationNum;
        // Skip the first render as we don't want to trigger the animation right off
        // the bat
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (shouldInterrupt) {
            return;
        }
        startTime.current = Date.now();
        setNormalizedTime(0);
        const tick = () => {
            rAF.current = requestAnimationFrame(() => {
                const currentTime = Date.now();
                const normalizedTime = Math.min(1, (currentTime - startTime.current) / durationMs);
                setNormalizedTime(normalizedTime);
                if (normalizedTime < 1) {
                    tick();
                }
                else {
                    // Clean up so we can use this value to determine if the most recent
                    // animation completed
                    rAF.current = undefined;
                }
            });
        };
        tick();
        return () => {
            // If the most recent animation did not complete, cut it short and reset
            // the animation
            if (rAF.current !== undefined) {
                cancelAnimationFrame(rAF.current);
                setNormalizedTime(1);
            }
        };
    }, [navigationNum, durationMs, shouldInterrupt]);
    return {
        isAnimating: normalizedTime !== 1,
        value: easingFunction(normalizedTime),
    };
};
exports.useTween = useTween;
//# sourceMappingURL=use-tween.js.map

/***/ }),

/***/ 802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(5893);
const react_1 = __webpack_require__(7294);
const utils_1 = __webpack_require__(1746);
const getSlideWidth = (count, wrapAround) => `${wrapAround ? 100 / (3 * count) : 100 / count}%`;
const getSlideStyles = (count, isCurrentSlide, isVisibleSlide, wrapAround, cellSpacing, animation, speed, zoomScale, adaptiveHeight, initializedAdaptiveHeight) => {
    const width = getSlideWidth(count, wrapAround);
    const visibleSlideOpacity = isVisibleSlide ? 1 : 0;
    const animationSpeed = animation === 'fade' ? 200 : 500;
    let height = 'auto';
    if (adaptiveHeight) {
        if (initializedAdaptiveHeight) {
            // Once adaptiveHeight is initialized, the frame will size to the height
            // of all the visible slides
            height = '100%';
        }
        else if (isVisibleSlide) {
            // If the slide is visible but we're still measuring heights, have
            // visible slides just take up their natural height
            height = 'auto';
        }
        else {
            // If the slide is not visible and we're still measuring heights, the
            // slide should have height 0 so it doesn't contribute to the measured
            // height of the frame
            height = '0';
        }
    }
    return {
        width,
        flex: 1,
        height,
        padding: `0 ${cellSpacing ? cellSpacing / 2 : 0}px`,
        transition: animation ? `${speed || animationSpeed}ms ease 0s` : undefined,
        transform: animation === 'zoom'
            ? `scale(${isCurrentSlide && isVisibleSlide ? 1 : zoomScale || 0.85})`
            : undefined,
        opacity: animation === 'fade' ? visibleSlideOpacity : 1,
    };
};
const generateIndex = (index, count, typeOfSlide) => {
    if (typeOfSlide === 'prev-cloned') {
        return index - count;
    }
    if (typeOfSlide === 'next-cloned') {
        return index + count;
    }
    return index;
};
const Slide = ({ count, children, currentSlide, index, isCurrentSlide, typeOfSlide, wrapAround, cellSpacing, animation, speed, slidesToShow, zoomScale, cellAlign, onVisibleSlideHeightChange, adaptiveHeight, initializedAdaptiveHeight, }) => {
    const customIndex = wrapAround
        ? generateIndex(index, count, typeOfSlide)
        : index;
    const isVisible = (0, utils_1.isSlideVisible)(currentSlide, customIndex, slidesToShow, cellAlign);
    const slideRef = (0, react_1.useRef)(null);
    const prevIsVisibleRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        var _a;
        const node = slideRef.current;
        if (node) {
            const slideHeight = (_a = node.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.height;
            if (isVisible) {
                node.removeAttribute('inert');
            }
            else {
                node.setAttribute('inert', 'true');
            }
            const prevIsVisible = prevIsVisibleRef.current;
            if (isVisible && !prevIsVisible) {
                onVisibleSlideHeightChange(customIndex, slideHeight);
            }
            else if (!isVisible && prevIsVisible) {
                onVisibleSlideHeightChange(customIndex, null);
            }
            prevIsVisibleRef.current = isVisible;
        }
    }, [
        adaptiveHeight,
        customIndex,
        isVisible,
        onVisibleSlideHeightChange,
        slidesToShow,
    ]);
    const currentSlideClass = isCurrentSlide && isVisible ? ' slide-current' : '';
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: slideRef, className: `slide${currentSlideClass}${typeOfSlide ? ` ${typeOfSlide}` : ''}${isVisible ? ' slide-visible' : ''}`, style: getSlideStyles(count, isCurrentSlide, isVisible, wrapAround, cellSpacing, animation, speed, zoomScale, adaptiveHeight, initializedAdaptiveHeight) }, { children: children })));
};
exports["default"] = Slide;
//# sourceMappingURL=slide.js.map

/***/ }),

/***/ 1843:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SliderList = exports.getPercentOffsetForSlide = void 0;
const jsx_runtime_1 = __webpack_require__(5893);
const react_1 = __importDefault(__webpack_require__(7294));
const default_controls_1 = __webpack_require__(2930);
const use_tween_1 = __webpack_require__(3457);
const getPercentOffsetForSlide = (currentSlide, slideCount, slidesToShow, cellAlign, wrapAround) => {
    // When wrapAround is enabled, we show the slides 3 times
    const renderedSlideCount = wrapAround ? 3 * slideCount : slideCount;
    const singleSlidePercentOfWhole = 100 / renderedSlideCount;
    // When wrap is on, -33.33% puts us right on the center, true set of slides
    // (the left and right sets are clones meant to avoid visual gaps)
    let slide0Offset = wrapAround ? -100 / 3 : 0;
    if (cellAlign === 'right' && slidesToShow > 1) {
        const excessSlides = slidesToShow - 1;
        slide0Offset += singleSlidePercentOfWhole * excessSlides;
    }
    if (cellAlign === 'center' && slidesToShow > 1) {
        const excessSlides = slidesToShow - 1;
        // Half of excess is on left and half is on right when centered
        const excessLeftSlides = excessSlides / 2;
        slide0Offset += singleSlidePercentOfWhole * excessLeftSlides;
    }
    const currentSlideOffsetFrom0 = (100 / renderedSlideCount) * currentSlide;
    return slide0Offset - currentSlideOffsetFrom0;
};
exports.getPercentOffsetForSlide = getPercentOffsetForSlide;
exports.SliderList = react_1.default.forwardRef(({ animation, animationDistance, cellAlign, children, currentSlide, disableAnimation, disableEdgeSwiping, draggedOffset, easing, edgeEasing, isDragging, scrollMode, slideCount, slidesToScroll, slidesToShow, speed, wrapAround, }, forwardedRef) => {
    // When wrapAround is enabled, we show the slides 3 times
    const renderedSlideCount = wrapAround ? 3 * slideCount : slideCount;
    const listVisibleWidth = `${(renderedSlideCount * 100) / slidesToShow}%`;
    const percentOffsetForSlideProps = [
        slideCount,
        slidesToShow,
        cellAlign,
        wrapAround,
    ];
    // We recycle dot index generation to determine the leftmost and rightmost
    // indices used, to be used in calculating the x-translation values we need
    // to limit to or when edgeEasing should be used.
    const dotIndexes = (0, default_controls_1.getDotIndexes)(slideCount, slidesToScroll, scrollMode, slidesToShow, wrapAround, cellAlign);
    let clampedDraggedOffset = `${draggedOffset}px`;
    if (isDragging && disableEdgeSwiping && !wrapAround) {
        const clampOffsets = [
            dotIndexes[0],
            dotIndexes[dotIndexes.length - 1],
        ].map((index) => (0, exports.getPercentOffsetForSlide)(index, ...percentOffsetForSlideProps));
        // Offsets are seemingly backwards because the rightmost slide creates
        // the most negative translate value
        clampedDraggedOffset = `clamp(${clampOffsets[1]}%, ${draggedOffset}px, ${clampOffsets[0]}%)`;
    }
    const slideBasedOffset = (0, exports.getPercentOffsetForSlide)(currentSlide, ...percentOffsetForSlideProps);
    const isEdgeEasing = !disableEdgeSwiping &&
        !wrapAround &&
        ((currentSlide === dotIndexes[0] && animationDistance < 0) ||
            (currentSlide === dotIndexes[dotIndexes.length - 1] &&
                animationDistance > 0));
    const { value: transition, isAnimating } = (0, use_tween_1.useTween)(speed, !isEdgeEasing ? easing : edgeEasing, 
    // animationDistance is assumed to be unique enough that it can be used to
    // detect when a new animation should start. This is used in addition to
    // currentSlide because some animations, such as those with edgeEasing, do
    // not occur due to a change in value of currentSlide
    currentSlide + animationDistance, isDragging || disableAnimation || animation === 'fade');
    // Return undefined if the transform would be 0 pixels since transforms can
    // cause flickering in chrome.
    let positioning;
    if (isDragging || slideBasedOffset !== 0 || isAnimating) {
        if (isDragging) {
            positioning = `translateX(${clampedDraggedOffset})`;
        }
        else {
            const transitionOffset = isAnimating
                ? (1 - transition) * animationDistance
                : 0;
            positioning = `translateX(calc(${slideBasedOffset}% - ${transitionOffset}px))`;
        }
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: forwardedRef, className: "slider-list", style: {
            width: listVisibleWidth,
            textAlign: 'left',
            userSelect: 'auto',
            transform: positioning,
            display: 'flex',
        } }, { children: children })));
});
exports.SliderList.displayName = 'SliderList';
//# sourceMappingURL=slider-list.js.map

/***/ }),

/***/ 6428:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ScrollMode = exports.Positions = exports.Directions = exports.Alignment = void 0;
/** @deprecated use string literals for the values instead */
var Alignment;
(function (Alignment) {
    Alignment["Center"] = "center";
    Alignment["Right"] = "right";
    Alignment["Left"] = "left";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
var Directions;
(function (Directions) {
    Directions["Next"] = "next";
    Directions["Prev"] = "prev";
    Directions["Up"] = "up";
    Directions["Down"] = "down";
})(Directions = exports.Directions || (exports.Directions = {}));
var Positions;
(function (Positions) {
    Positions["TopLeft"] = "TopLeft";
    Positions["TopCenter"] = "TopCenter";
    Positions["TopRight"] = "TopRight";
    Positions["CenterLeft"] = "CenterLeft";
    Positions["CenterCenter"] = "CenterCenter";
    Positions["CenterRight"] = "CenterRight";
    Positions["BottomLeft"] = "BottomLeft";
    Positions["BottomCenter"] = "BottomCenter";
    Positions["BottomRight"] = "BottomRight";
})(Positions = exports.Positions || (exports.Positions = {}));
var ScrollMode;
(function (ScrollMode) {
    ScrollMode["page"] = "page";
    ScrollMode["remainder"] = "remainder";
})(ScrollMode = exports.ScrollMode || (exports.ScrollMode = {}));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 1746:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getBoundedIndex = exports.getDefaultSlideIndex = exports.getPrevMoveIndex = exports.getNextMoveIndex = exports.isSlideVisible = void 0;
const default_controls_1 = __webpack_require__(2930);
const types_1 = __webpack_require__(6428);
const isSlideVisible = (currentSlide, indexToCheck, slidesToShow, cellAlign) => {
    // The addition or subtraction of constants (1 , 0.5) in the following
    // calculations are accounting for the fact that a slide will be visible even
    // after the position associated with its index is off-screen. For example,
    // with cellAlign="left", slidesToShow=1 and indexToCheck=0,
    // if the currentSlide is set to 0.99, both (a sliver of) slide 0 and slide 1
    // will be visible at the same time, even though the position we associate
    // with index 0, its leftmost edge, is off-screen.
    if (cellAlign === 'left') {
        return (indexToCheck < currentSlide + slidesToShow &&
            indexToCheck > currentSlide - 1);
    }
    if (cellAlign === 'center') {
        return ((indexToCheck > currentSlide - slidesToShow / 2 - 0.5 &&
            indexToCheck <= currentSlide) ||
            (indexToCheck > currentSlide &&
                indexToCheck < currentSlide + slidesToShow / 2 + 0.5));
    }
    if (cellAlign === 'right') {
        return (indexToCheck < currentSlide + 1 &&
            indexToCheck > currentSlide - slidesToShow);
    }
    return false;
};
exports.isSlideVisible = isSlideVisible;
const getNextMoveIndex = (scrollMode, wrapAround, currentSlide, slideCount, slidesToScroll, slidesToShow, cellAlign) => {
    if (wrapAround) {
        return currentSlide + slidesToScroll;
    }
    // Quit early if we're already as far right as we can go
    if (currentSlide >= slideCount - 1 ||
        (cellAlign === 'left' && currentSlide >= slideCount - slidesToShow)) {
        return currentSlide;
    }
    if (scrollMode === types_1.ScrollMode.remainder && cellAlign === 'left') {
        return Math.min(currentSlide + slidesToScroll, slideCount - slidesToShow);
    }
    return Math.min(currentSlide + slidesToScroll, slideCount - 1);
};
exports.getNextMoveIndex = getNextMoveIndex;
const getPrevMoveIndex = (scrollMode, wrapAround, currentSlide, slidesToScroll, slidesToShow, cellAlign) => {
    if (wrapAround) {
        return currentSlide - slidesToScroll;
    }
    // Quit early if we're already as far left as we can go
    if (currentSlide <= 0 ||
        (cellAlign === 'right' && currentSlide <= slidesToShow - 1)) {
        return currentSlide;
    }
    if (scrollMode === types_1.ScrollMode.remainder && cellAlign === 'right') {
        return Math.max(currentSlide - slidesToScroll, slidesToShow - 1);
    }
    return Math.max(currentSlide - slidesToScroll, 0);
};
exports.getPrevMoveIndex = getPrevMoveIndex;
const getDefaultSlideIndex = (slideIndex, slideCount, slidesToShow, slidesToScroll, cellAlign, autoplayReverse, scrollMode) => {
    if (slideIndex !== undefined) {
        return slideIndex;
    }
    const dotIndexes = (0, default_controls_1.getDotIndexes)(slideCount, slidesToScroll, scrollMode, slidesToShow, false, cellAlign);
    return autoplayReverse ? dotIndexes[dotIndexes.length - 1] : dotIndexes[0];
};
exports.getDefaultSlideIndex = getDefaultSlideIndex;
/**
 * Boils down an unbounded index (-Infinity < index < Infinity) to a bounded one
 * (0 ≤ index < slideCount)
 */
const getBoundedIndex = (rawIndex, slideCount) => {
    return ((rawIndex % slideCount) + slideCount) % slideCount;
};
exports.getBoundedIndex = getBoundedIndex;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 7037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-function.es.js
const isFunction = (value) => typeof value === "function";



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = resolveElements(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (isFunction(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}




/***/ })

}]);